"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapmakerModalProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
require("./MapmakerModalFix.css");
const MapmakerModalContext = (0, react_1.createContext)({});
const MapmakerModalProvider = function ({ onModalChange, children, }) {
    const [modalRoot, setModalRootDirect] = (0, react_1.useState)();
    function setModalRoot(modalRoot) {
        if (modalRoot) {
            modalRoot.classList.add("mapmaker-modal-fix");
        }
        setModalRootDirect(modalRoot);
    }
    return ((0, jsx_runtime_1.jsx)(MapmakerModalContext.Provider, Object.assign({ value: {
            onModalChange,
            modalRoot,
            setModalRoot,
        } }, { children: children })));
};
exports.MapmakerModalProvider = MapmakerModalProvider;
function useMapmakerModals() {
    return (0, react_1.useContext)(MapmakerModalContext);
}
exports.default = useMapmakerModals;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlTWFwbWFrZXJNb2RhbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zaGFyZWQvbW9kYWxzL3VzZU1hcG1ha2VyTW9kYWxzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsaUNBQXVFO0FBQ3ZFLGtDQUFnQztBQVFoQyxNQUFNLG9CQUFvQixHQUFHLElBQUEscUJBQWEsRUFDeEMsRUFBMEIsQ0FDM0IsQ0FBQztBQU9LLE1BQU0scUJBQXFCLEdBQUcsVUFBUyxFQUM1QyxhQUFhLEVBQ2IsUUFBUSxHQUNtQjtJQUMzQixNQUFNLENBQUMsU0FBUyxFQUFFLGtCQUFrQixDQUFDLEdBQUcsSUFBQSxnQkFBUSxHQUFlLENBQUM7SUFFaEUsU0FBUyxZQUFZLENBQUMsU0FBc0I7UUFDMUMsSUFBSSxTQUFTLEVBQUU7WUFDYixTQUFTLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDO1NBQy9DO1FBQ0Qsa0JBQWtCLENBQUMsU0FBUyxDQUFDLENBQUM7SUFDaEMsQ0FBQztJQUVELE9BQU8sQ0FDTCx1QkFBQyxvQkFBb0IsQ0FBQyxRQUFRLGtCQUM1QixLQUFLLEVBQUU7WUFDTCxhQUFhO1lBQ2IsU0FBUztZQUNULFlBQVk7U0FDYixnQkFFQSxRQUFRLElBQ3FCLENBQ2pDLENBQUM7QUFDSixDQUFDLENBQUM7QUF4QlcsUUFBQSxxQkFBcUIseUJBd0JoQztBQUVGLFNBQXdCLGlCQUFpQjtJQUN2QyxPQUFPLElBQUEsa0JBQVUsRUFBQyxvQkFBb0IsQ0FBQyxDQUFDO0FBQzFDLENBQUM7QUFGRCxvQ0FFQyJ9